import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "fields"]
  static values = { showWhen: { type: String, default: "true" } }

  connect() {
    this.toggle()
  }

  toggle() {
    const show = this.selectTarget.value === this.showWhenValue
    this.fieldsTarget.classList.toggle("hidden", !show)
  }
}
